export const TenantAdminMenu = [
  //Dashboard
  {
    title: "Main Menu",
    classsChange: "menu-title",
    extraclass: "first",
  },

  {
    title: "My Academies",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-users" />,
    content: [
      {
        title: "Tenants List",
        to: "registered-academies-list",
      },
      {
        title: "Register Tenant",
        to: "registered-new-academy",
      },
    ],
  },
];
